<script setup lang="ts">
import { ALERT_STATUS } from "~/common/interfaces/alert-status.enum";
import type { LoginDto } from "~/common/interfaces/dto/auth/login.dto";
import { useAlertStore } from "~/stores/alert";
import { useAuthStore } from "~/stores/auth";

definePageMeta({
	layout: "auth"
});

const { t } = useI18n();
const authStore = useAuthStore();
const alertStore = useAlertStore();

const handleLoginUser = async (dto: LoginDto) => {
	await authStore.login(dto);

	navigateTo("/orders");

	alertStore.addAlert({
		title: t("COMMON.success"),
		description: t("PAGES.LOGIN.alert.description"),
		status: ALERT_STATUS.SUCCESS
	});
};
</script>

<template>
	<LoginModal @submit="handleLoginUser" />
</template>
